import { Avatar, Box, Typography } from "@mui/material";

const ProfileDetailsCard = ({ userProfileData }) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Box>
        {" "}
        <Avatar
          src="/images/header/dummy-profile-pic.png"
          sx={{
            width: 40,
            height: 40,
            cursor: "pointer",
          }}
        />
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography
          sx={{ fontWeight: "semibold", fontSize: "14px", color: "#201F1E" }}
        >
          {userProfileData.name}
        </Typography>
        <Typography
          sx={{ fontWeight: "semibold", fontSize: "12px", color: "#969696" }}
        >
          {userProfileData.email}
        </Typography>
      </Box>
    </Box>
  );
};

export default ProfileDetailsCard;
